module.exports = __webpack_public_path__ + "media/video1.ffe337e7.mp4";